import { boolean, object, string } from 'yup';
import { passwordSchema } from './password.schema';
import { CommonValidationTranslations } from '@/core/utils/commonValidationTranslations';
import { t } from '@lingui/core/macro';

export const registerSchema = object().shape({
  firstName: string()
    .trim()
    .required(() => CommonValidationTranslations.requiredField()),
  lastName: string()
    .trim()
    .required(() => CommonValidationTranslations.requiredField()),
  email: string()
    .trim()
    .email(() =>
      CommonValidationTranslations.invalidField(
        t({
          id: 'auth.forms.email',
          message: 'E-mail',
        }),
      ),
    )
    .required(() => CommonValidationTranslations.requiredField()),
  password: passwordSchema,
  terms: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
  privacy: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
});
